import React from 'react';
import type { CheckoutLinkData } from '../../utils/productBlocks';

interface CheckoutLinkProps extends CheckoutLinkData {
  isDark: boolean;
}

const CheckoutLink: React.FC<CheckoutLinkProps> = ({
  url,
  total,
  items,
  isDark,
}) => {
  const cardBg = isDark ? 'rgba(34,197,94,0.1)' : 'rgba(34,197,94,0.06)';
  const borderColor = isDark ? '#166534' : '#86efac';
  const titleColor = isDark ? '#4ade80' : '#15803d';
  const subColor = isDark ? '#9ca3af' : '#6b7280';

  return (
    <div
      style={{
        background: cardBg,
        border: `1px solid ${borderColor}`,
        borderRadius: '12px',
        padding: '14px 16px',
        margin: '8px 0',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
        <span style={{ fontSize: '16px' }}>&#128722;</span>
        <span style={{ fontSize: '14px', fontWeight: 700, color: titleColor }}>
          Complete your order
        </span>
      </div>

      <div style={{ fontSize: '12px', color: subColor, marginBottom: '4px' }}>
        {items}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px' }}>
        <span style={{ fontSize: '16px', fontWeight: 700, color: isDark ? '#ffffff' : '#111827' }}>
          {total}
        </span>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontSize: '13px',
            fontWeight: 600,
            color: '#ffffff',
            background: '#16a34a',
            padding: '6px 16px',
            borderRadius: '8px',
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          Go to Checkout &#8594;
        </a>
      </div>
    </div>
  );
};

export default CheckoutLink;
